// extracted by mini-css-extract-plugin
module.exports = {"root":"StoreTab_root__niqZW"};